import * as CryptoJS from "crypto-js";
import axios from "axios";

/* Method for Encryption */
export const encrypt = (value: any, key: string) => {
  value = value instanceof String ? value : JSON.stringify(value);
  const encrypted = CryptoJS.AES.encrypt(value, key, { mode: CryptoJS.mode.CBC }).toString();
  return encrypted;
};

/* Method for Decryption */
export const decrypt = (value: any, key: string): string => {
  const decrypted = CryptoJS.AES.decrypt(value, key).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decrypted);
};

export async function computeHashFromUrl(url: string): Promise<string> {
  try {
    // Fetch the data as an array buffer
    const response = await axios.get(url, { responseType: "arraybuffer" });
    const data = response.data;

    // Convert the data to a CryptoJS WordArray
    const wordArray = CryptoJS.lib.WordArray.create(data);

    // Compute the SHA-256 hash
    const hash = CryptoJS.SHA256(wordArray);

    // Return the hash as a hexadecimal string
    return hash.toString(CryptoJS.enc.Hex);
  } catch (error: any) {
    throw new Error(`Failed to compute hash: ${error.message}`);
  }
}

export const computeHashFromBase64 = async (base64: string): Promise<string> => {
  let base64Data: string;
  let mimeType: string | null = null;

  // Check if base64 includes MIME type
  const mimeMatch = base64.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64/);

  if (mimeMatch) {
    // If a MIME type is found, extract it and the actual base64 data
    mimeType = mimeMatch[1];
    base64Data = base64.split(",")[1];
  } else {
    // If no MIME type, assume the entire string is base64 data
    base64Data = base64;
  }

  // Decode the base64 string to a byte array
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Create a Blob (use a generic MIME type if none is provided)
  const blob = new Blob([byteArray], { type: mimeType || "application/octet-stream" });

  // Read the Blob content as ArrayBuffer for hash computation
  const arrayBuffer = await blob.arrayBuffer();

  // Compute the hash using SHA-256
  const hashBuffer = await crypto.subtle.digest("SHA-256", arrayBuffer);

  // Convert the hash to a hexadecimal string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, "0")).join("");

  return hashHex;
};
